import { GLOBAL_ENV } from './constant';


const websiteURL = {
	dev: 'http://website-test.jzfz.local:8048/website',   // 开发环境
	test: 'http://website-test.jzfz.local:8048/website',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://www.jzfz.com.cn/website',  // 生产环境
};

// 官网数据接口地址
export const GLOBAL_WEBSITE_URL = GLOBAL_ENV ? websiteURL[GLOBAL_ENV] : websiteURL.dev;


// 官网数据管理后台接口地址
const webSiteCmsUrl = {
    dev: 'http://website-cms-test.jzfz.local:8049/cms',   // 开发环境
    test: 'http://website-cms-test.jzfz.local:8049/cms',  // 测试环境
    uat: '',   // uat环境
    prod: 'http://website-admin.jzfz.local/cms',  // 生产环境
};
export const GLOBAL_WEBSITE_CMS_URL = GLOBAL_ENV ? webSiteCmsUrl[GLOBAL_ENV] : webSiteCmsUrl.dev;



// 用户中心接口
const userCenterPrefix = {
	dev: 'http://192.168.13.11:8081/user-center',   // 开发环境
	test: 'http://192.168.13.11:8081/user-center',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.232:8081/user-center',  // 生产环境
}
export const GLOBAL_USER_CENTER_API = userCenterPrefix[GLOBAL_ENV];



// BOSS接口
const bossURL = {
	dev: 'http://192.168.13.11:8083/boss',   // 开发环境
	test: 'http://192.168.13.11:8083/boss',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.232:8083/boss',  // 生产环境
}
export const GLOBAL_BOSS_API = bossURL[GLOBAL_ENV];// BOSS接口

// 文件预览地址
const attachmentPreviewURL = {
	dev: 'http://192.168.13.13:8070',   // 开发环境
	test: 'http://192.168.13.13:8070',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.231:8070',  // 生产环境
}
export const GLOBAL_ATTACHMENT_PREVIEW_URL = attachmentPreviewURL[GLOBAL_ENV];

// 文件上传地址
const fileUploadURL = {
	dev: 'http://oss-api-test.jzfz.local:9002',   // 开发环境
	test: 'http://oss-api-test.jzfz.local:9002',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.238:9002',  // 生产环境
}
export const GLOBAL_FILE_UPLOAD_URL = fileUploadURL[GLOBAL_ENV];


// 立项管理接口
const ProjectApprovalURL = {
	dev: 'http://192.168.13.13:8074',   // 开发环境
	test: 'http://192.168.13.13:8074',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.231:8074',  // 生产环境
}
export const GLOBAL_PROJECT_APPROVAL_API = ProjectApprovalURL[GLOBAL_ENV];



/**
 ************************* 知识库 *************************
 */


// 普通请求
const baseURL = {
	dev: 'http://192.168.13.11:8070/standard-detail',       // 开发环境
	test: 'http://192.168.13.11:8070/standard-detail',      // 测试环境
	uat: '',       // uat环境
	prod: 'http://192.168.249.232:8070/standard-detail',      // 生产环境
}
export const GLOBAL_STANDARD_API = GLOBAL_ENV ? baseURL[GLOBAL_ENV] : baseURL.dev;


// 规定问题
const rulesProblemURL = {
	dev: 'http://192.168.13.11:8072/company-regulation',   // 开发环境
	test: 'http://192.168.13.11:8072/company-regulation',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.232:8072/company-regulation',  // 生产环境
}
export const GLOBAL_RULES_PROBLEM_API = GLOBAL_ENV ? rulesProblemURL[GLOBAL_ENV] : rulesProblemURL.dev;


// 学习资料接口地址
const learnDataBaseURL = {
	dev: 'http://192.168.13.11:8073/learning-materials', // 开发环境
	test: 'http://192.168.13.11:8073/learning-materials', // 测试环境
	uat: '', // uat环境
	prod: 'http://192.168.249.232:8073/learning-materials', // 生产环境
}
export const GLOBAL_LEARN_DATA_API = GLOBAL_ENV ? learnDataBaseURL[GLOBAL_ENV] : learnDataBaseURL.dev;


// 标准任务
const standardTaskBaseURL = {
	dev: 'http://192.168.13.11:8075/standard-mission', // 开发环境
	test: 'http://192.168.13.11:8075/standard-mission', // 测试环境
	uat: '', // uat环境
	prod: 'http://192.168.249.232:8075/standard-mission', // 生产环境
}
export const GLOBAL_STANDARD_TASK_API = GLOBAL_ENV ? standardTaskBaseURL[GLOBAL_ENV] : standardTaskBaseURL.dev;


// 标签管理
const labelManageBaseURL = {
	dev: 'http://192.168.13.11:8086/label', // 开发环境
	test: 'http://192.168.13.11:8086/label', // 测试环境
	uat: '', // uat环境
	prod: 'http://192.168.249.232:8086/label', // 生产环境
}
export const GLOBAL_LABEL_MANAGE_API = GLOBAL_ENV ? labelManageBaseURL[GLOBAL_ENV] : labelManageBaseURL.dev;


// 标准图集
const standardMapBaseURL = {
	dev: 'http://192.168.13.11:8071/standard-map', // 开发环境
	test: 'http://192.168.13.11:8071/standard-map', // 测试环境
	uat: '', // uat环境
	prod: 'http://192.168.249.232:8071/standard-map', // 生产环境
}
export const GLOBAL_STANDARD_MAP_API = GLOBAL_ENV ? standardMapBaseURL[GLOBAL_ENV] : standardMapBaseURL.dev;


// 典型问题
const typicalQuestionBaseURL = {
	dev: 'http://192.168.13.11:8076/typical-problem', // 开发环境
	test: 'http://192.168.13.11:8076/typical-problem', // 测试环境
	uat: '', // uat环境
	prod: 'http://192.168.249.232:8076/typical-problem', // 生产环境
}
export const GLOBAL_TYPICAL_QUESTION_API = GLOBAL_ENV ? typicalQuestionBaseURL[GLOBAL_ENV] : typicalQuestionBaseURL.dev;


// 全局搜索
const knowledgeSearchURL = {
	dev: 'http://192.168.13.11:8089/elastic-search',       // 开发环境
	test: 'http://192.168.13.11:8089/elastic-search',      // 测试环境
	uat: '',       // uat环境
	prod: 'http://192.168.249.232:8089/elastic-search',      // 生产环境
}
export const GLOBAL_KNOWLEDGE_SEARCH_API = GLOBAL_ENV ? knowledgeSearchURL[GLOBAL_ENV] : knowledgeSearchURL.dev;


// 关联模块
const connectURL = {
	dev: 'http://192.168.13.11:8085/connect',       // 开发环境
	test: 'http://192.168.13.11:8085/connect',      // 测试环境
	uat: '',       // uat环境
	prod: 'http://192.168.249.232:8085/connect',      // 生产环境
}
export const GLOBAL_CONNECTION_API = GLOBAL_ENV ? connectURL[GLOBAL_ENV] : connectURL.dev;


// 个人中心
const userCenterURL = {
	dev: 'http://192.168.13.11:8084/personal-center',       // 开发环境
	test: 'http://192.168.13.11:8084/personal-center',      // 测试环境
	uat: '',       // uat环境
	prod: 'http://192.168.249.232:8084/personal-center',      // 生产环境
}
export const GLOBAL_PERSONAL_CENTER_API = GLOBAL_ENV ? userCenterURL[GLOBAL_ENV] : userCenterURL.dev;





// OCR文字识别接口
const ocrUrl: any = {
	dev: 'http://192.168.13.11:8063/ocr',   // 开发环境
	test: 'http://192.168.13.11:8063/ocr',  // 测试环境
	uat: '',   // uat环境（无UAT环境暂用生产接口替代）
	prod: 'http://192.168.249.232:8063/ocr',  // 生产环境
}
export const GLOBAL_OCR_API = GLOBAL_ENV ? ocrUrl[GLOBAL_ENV] : ocrUrl.dev;




// 题库
const examURL: any = {
	dev: 'http://192.168.13.11:8078/exam',   // 开发环境
	test: 'http://192.168.13.11:8078/exam',  // 测试环境
	uat: '',   // uat环境
	prod: 'http://192.168.249.232:8078/exam',  // 生产环境
}
export const GLOBAL_EXAM_API = GLOBAL_ENV ? examURL[GLOBAL_ENV] : examURL.dev;